import React from 'react'

export const IconGridSizeMinimised = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="3" y="2" width="3" height="20" rx="1.5" fill="currentColor" />
    <rect x="8" y="2" width="3" height="20" rx="1.5" fill="currentColor" />
    <rect x="13" y="2" width="3" height="20" rx="1.5" fill="currentColor" />
    <rect x="18" y="2" width="3" height="20" rx="1.5" fill="currentColor" />
  </svg>
)
